module.exports = __webpack_public_path__ + "static/media/logo.946ac76e.png";